import { GlobalSearchRepository } from '../repositories/global_search.repository'
import { GlobalSearchResponseT } from '../types/global_search.types'

const globalSearchRepository = new GlobalSearchRepository()

export class GlobalSearchService {
    async search(name: string): Promise<GlobalSearchResponseT> {
        const response = await globalSearchRepository.search(name)
        return response.data
    }
}
